import { baseApi } from '@klp/core/api';
import { FrontpageApiRoutes } from '../config';
import type { AggregateRequest } from '../classes';
import { Aggregate } from '../classes';
import type { IAggregate } from '../interfaces';

export const frontpageApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getFrontpageAggregates: build.query<Aggregate, AggregateRequest>({
            query: (requestParams) => ({
                url: FrontpageApiRoutes.aggregates(),
                params: requestParams,
                method: 'GET',
            }),
            transformResponse: (response: IAggregate) => {
                return Aggregate.parseObject(response);
            },
            providesTags: ['frontpageAggregate'],
        }),
    }),
});

export const {
    useGetFrontpageAggregatesQuery,
    useLazyGetFrontpageAggregatesQuery,
} = frontpageApi;
